<template>
  <vs-popup
    class="vs-con-loading__container user-edit-popup"
    id="popup"
    title="DOWNLOAD RAW MATERIAL BATCH CONSUMPTION DOCUMENT"
    @close="open = false"
    :active.sync="open"
    :buttons-hidden="true"
  >
    <vx-card no-shadow>
      <ValidationObserver ref="form" v-slot="{ handleSubmit }">
        <form
          @submit.prevent="handleSubmit(downloadReportDocument)"
          autocomplete="off"
        >
          <div class="vx-row mb-3">
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider
                vid="from"
                name="from"
                rules="required"
                v-slot="{ errors }"
              >
                <small class="label">From</small>
                <flat-pickr
                  style="display: none"
                  class="w-full"
                  :config="{ dateFormat: 'd/m/Y' }"
                  v-model="from_date"
                  placeholder="Choose Date"
                />
                <flat-pickr
                  class="w-full"
                  :config="{ dateFormat: 'd/m/Y' }"
                  v-model="from_date"
                  placeholder="Choose Date"
                />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider
                vid="to"
                name="to"
                rules="required"
                v-slot="{ errors }"
              >
                <small class="label">To</small>
                <flat-pickr
                  style="display: none"
                  class="w-full"
                  :config="{ dateFormat: 'd/m/Y' }"
                  v-model="to_date"
                  placeholder="Choose Date"
                />
                <flat-pickr
                  class="w-full"
                  :config="{ dateFormat: 'd/m/Y' }"
                  v-model="to_date"
                  placeholder="Choose Date"
                />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>
          <div class="vx-row mb-3">
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider
                vid="supplier-id"
                name="supplier-id"
                rules=""
                v-slot="{ errors }"
              >
                <small class="label">Suppliers</small>
                <v-select
                  :clearable="true"
                  placeholder="Suppliers"
                  v-model="selectedSuppliers"
                  :options="suppliers"
                  label="name"
                  :reduce="(option) => option.value"
                  :dir="$vs.rtl ? 'rtl' : 'ltr'"
                ></v-select>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider
                vid="raw-material-id"
                name="raw-material-id"
                rules=""
                v-slot="{ errors }"
              >
                <small class="label">Raw Materials</small>
                <v-select
                  :clearable="true"
                  placeholder="Raw Materials"
                  v-model="selectedRawMaterials"
                  :options="rawMaterials"
                  label="name"
                  :reduce="(option) => option.value"
                  :dir="$vs.rtl ? 'rtl' : 'ltr'"
                ></v-select>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>
          <div class="flex flex-wrap items-center justify-end mt-8">
            <vs-button button="submit" class="ml-auto mt-2">Download</vs-button>
          </div>
        </form>
      </ValidationObserver>
    </vx-card>
  </vs-popup>
</template>

<script>
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import { RepositoryFactory } from "@/repository/RepositoryFactory";
const ReportingRepository = RepositoryFactory.get("reporting");
import "flatpickr/dist/plugins/monthSelect/style.css";
import Utils from "@/mixins/Utils";
import ErrorMessages from "@/mixins/ErrorMessages";
import vSelect from "vue-select";

export default {
  name: "DownloadRawMaterialBatchConsumptionDocumentPopUp",
  data() {
    return {
      open: false,
      endPoint: "consumption-report/raw-material-batch-usage",
      to_date: "",
      from_date: "",
      selectedSuppliers: "",
      selectedRawMaterials: "",
    };
  },
  mixins: [Utils, ErrorMessages],
  components: {
    flatPickr,
    "v-select": vSelect,
  },
  methods: {
    openPopup(end_point, from, to, filters) {
      this.endPoint = "consumption-report/raw-material-batch-usage";
      this.suppliers = this.$store.getters.suppliers;
      this.rawMaterials = this.$store.getters.raw_materials;
      this.open = true;
      if(filters['raw-material-id'] || filters['supplier-id']){
        this.selectedSuppliers = filters['supplier-id'] || null
        this.selectedRawMaterials = filters['raw-material-id'] || null
      }
      if (from && to) {
        this.from_date = from;
        this.to_date = to;
      }
    },

    async downloadReportDocument() {
      this.$vs.loading();
      try {
        const params = [
          `from=${this.from_date}`,
          `to=${this.to_date}`
        ]

        if (this.selectedSuppliers && this.selectedSuppliers.length) {
          params.push(`supplier-id=${this.selectedSuppliers}`)
        }

        if (this.selectedRawMaterials && this.selectedRawMaterials.length) {
          params.push(`raw-material-id=${this.selectedRawMaterials}`)
        }

        const response = await ReportingRepository.downloadSalesReportDocument(
          this.endPoint,
          params.join('&')
        )
        let fileURL = window.URL.createObjectURL(new Blob([response.data]));
        let fileLink = document.createElement("a");
        fileLink.href = fileURL;
        fileLink.setAttribute(
          "download",
          `Raw Material Batch Consumption Document (${this.from_date} - ${this.to_date}).xlsx`
        );
        document.body.appendChild(fileLink);
        fileLink.click();
        this.open = false;
      } catch (e) {
        this.convertAndNotifyError(e);
      }
      this.$vs.loading.close();
    },
  },
};
</script>

<style scoped>
</style>
